import { SearchBarContext, useSearchBarState, useSearchBase } from '@hb/react'
import { FC, PropsWithChildren, useRef } from 'react'

export const SearchBarProvider: FC<
  PropsWithChildren<{
    transformQuery?: (query: string) => string
  }>
> = ({ children, transformQuery }) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  return (
    <SearchBarContext.Provider value={useSearchBarState(inputRef, transformQuery)}>
      {children}
    </SearchBarContext.Provider>
  )
}

export const useSearch = () => useSearchBase<HTMLInputElement>()
